/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
    WorkspaceConnection,
    WorkspaceConnectionFromJSON,
    WorkspaceConnectionFromJSONTyped,
    WorkspaceConnectionToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspaceConnectionsResponse
 */
export interface WorkspaceConnectionsResponse {
    /**
     * 
     * @type {Array<WorkspaceConnection>}
     * @memberof WorkspaceConnectionsResponse
     */
    results: Array<WorkspaceConnection>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof WorkspaceConnectionsResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof WorkspaceConnectionsResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof WorkspaceConnectionsResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof WorkspaceConnectionsResponse
     */
    hasPreviousPage?: boolean;
}

export function WorkspaceConnectionsResponseFromJSON(json: any): WorkspaceConnectionsResponse {
    return WorkspaceConnectionsResponseFromJSONTyped(json, false);
}

export function WorkspaceConnectionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceConnectionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(WorkspaceConnectionFromJSON)),
        'listResult': json['listResult'],
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function WorkspaceConnectionsResponseToJSON(value?: WorkspaceConnectionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(WorkspaceConnectionToJSON)),
        'listResult': value.listResult,
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}


